module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', [(!_vm.showTable) ? _c('v-message', {
    attrs: {
      "warning": _vm.$t('static.orders.edit.noProductWarning')
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "tableContainer"
  }, [_c('el-row', {
    staticClass: "tablerow"
  }, [_c('el-col', {
    staticClass: "tableCol colHeading",
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.name.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
    staticClass: "tableCol colHeading",
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.price.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
    staticClass: "tableCol colHeading",
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.quantityOrdered.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
    staticClass: "tableCol colHeading",
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.quantityConfirmed.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
    staticClass: "tableCol colHeading",
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.quantityReceived.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
    staticClass: "tableCol colHeading",
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n         \n      ")])], 1), _vm._v(" "), _vm._l((_vm.ediOrderItems), function(p) {
    return _c('el-row', {
      key: p.id,
      staticClass: "tablerow"
    }, [_c('el-col', {
      staticClass: "tableCol",
      attrs: {
        "span": 4,
        "data-th": "Product Name"
      }
    }, [_vm._v("\n       " + _vm._s(p.description) + "\n      ")]), _vm._v(" "), _c('el-col', {
      staticClass: "tableCol",
      attrs: {
        "span": 4,
        "data-th": "Price"
      }
    }, [_vm._v("\n        " + _vm._s(p.price) + "\n      ")]), _vm._v(" "), _c('el-col', {
      staticClass: "tableCol",
      attrs: {
        "span": 4,
        "data-th": "Ordered"
      }
    }, [_vm._v("\n        " + _vm._s(p.quantityOrdered) + "\n      ")]), _vm._v(" "), _c('el-col', {
      staticClass: "tableCol",
      attrs: {
        "span": 4,
        "data-th": "Confirmed"
      }
    }, [_vm._v("\n        " + _vm._s(p.quantityConfirmed) + "\n      ")]), _vm._v(" "), _c('el-col', {
      staticClass: "tableCol",
      attrs: {
        "span": 4,
        "data-th": "Received"
      }
    }, [_vm._v("\n        " + _vm._s(p.quantityReceived) + "\n      ")]), _vm._v(" "), _c('el-col', {
      staticClass: "tableCol buttonCol",
      attrs: {
        "span": 4
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('br')], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.ready),
      expression: "!ready"
    }]
  }, [_c('br'), _c('br'), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-338ba76b","hasScoped":false}!./src/app/components/originalOrderItems/originalOrderItems.html
// module id = 2964
// module chunks = 1